export default "__VITE_ASSET__BqZrY$Lv__"